import Vue from 'vue'
import Router from 'vue-router'
import home from '@/components/home'
import signup from '@/components/signup'
import signupMon from '@/components/signupMon'
import signupWed from '@/components/signupWed'
import signupThur from '@/components/signupThur'
import signupMon2 from '@/components/signupMon2'
import signupTue2 from '@/components/signupTue2'
import signupWed2 from '@/components/signupWed2'
import signupThur2 from '@/components/signupThur2'
// import signupSat from '@/components/signupSat'
import contact from '@/components/contact'
import about from '@/components/about'
import pay from '@/components/pay'
import videos from '@/components/videos'
import photos from '@/components/photos'
import camp from '@/components/camp'
import adaptive from '@/components/adaptive'
import popup from '@/components/popup'
import patterns from '@/components/patterns'
Vue.use(Router)

export default new Router({
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      name: 'home',
      component: home
    },
    {
      path: '/signup',
      name: 'signup',
      component: signup
    },
    {
      path: '/signup/mon',
      name: 'signupMon',
      component: signupMon
    },
    {
      path: '/signup/wed',
      name: 'signupWed',
      component: signupWed
    },
    {
      path: '/signup/thur',
      name: 'signupThur',
      component: signupThur
    },
    {
      path: '/signup/mon2',
      name: 'signupMon2',
      component: signupMon2
    },
    {
      path: '/signup/tue2',
      name: 'signupTue2',
      component: signupTue2
    },
    {
      path: '/signup/wed2',
      name: 'signupWed2',
      component: signupWed2
    },
    {
      path: '/signup/thur2',
      name: 'signupThur2',
      component: signupThur2
    },
    // {
    //   path: '/signup/sat',
    //   name: 'signupSat',
    //   component: signupSat
    // },
    {
      path: '/pay',
      name: 'pay',
      component: pay
    },
    {
      path: '/photos',
      name: 'photos',
      component: photos
    },
    {
      path: '/videos',
      name: 'videos',
      component: videos
    },
    {
      path: '/patterns',
      name: 'patterns',
      component: patterns
    },
    {
      path: '/camp',
      name: 'camp',
      component: camp
    },
    {
      path: '/adaptive',
      name: 'adaptive',
      component: adaptive
    },
    {
      path: '/popup',
      name: 'popup',
      component: popup
    },
    {
      path: '/about',
      name: 'about',
      component: about
    },
    {
      path: '/contact',
      name: 'contact',
      component: contact
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js